import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {PrimaryButton, DangerButton} from 'Components/Button';

import User from 'Services/Api/Admin/Users';
import {Toast} from 'Services';

export default class ConfirmEmail extends React.Component {
    /**
     * @var state
     * @type {{working: boolean}}
     */
    state = {
        working: false
    };

    /**
     * @method handleSend
     * @return {Promise<void>}
     */
    handleSend = async () => {
        this.setState({
            working: true
        });

        const request = await User.sendEmail(this.props.user.id, this.props.type);

        if (request.success) {
            Toast.success(`${this.props.type} has been sent to the user`);

            return this.props.onClose();
        }

        Toast.error();

        this.setState({
            working: false
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {user, type} = this.props;
        const {working} = this.state;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    Are you sure?
                </ModalHeader>

                <ModalBody>
                    <p className="text-center">
                        Are you sure you want to send an {type} to {user.first_name} {user.last_name} ({user.email})
                    </p>
                </ModalBody>

                <ModalFooter alignment="center">
                    <PrimaryButton className="mr-2" text="Cancel" onClick={this.props.onClose} />
                    <DangerButton
                        onClick={this.handleSend} text="Continue"
                        working={working}
                    />
                </ModalFooter>
            </Modal>
        )
    }
};
